import { render, staticRenderFns } from "./IsoXmlConverter.vue?vue&type=template&id=0a485797&lang=html&"
import script from "./IsoXmlConverter.vue?vue&type=script&lang=js&"
export * from "./IsoXmlConverter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports